import { createContext } from 'react';
import { defaultGridColumns, defaultSpacing } from './constants';
/**
 * __Grid context__
 *
 * Provides contextual information which is used by both
 * the `Grid` and its `GridColumn` children.
 *
 * @internal
 */
export var GridContext = /*#__PURE__*/createContext({
  isRoot: true,
  isNested: false,
  spacing: defaultSpacing,
  columns: defaultGridColumns
});